var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.indexMenus.length)?_c('Top'):_vm._e(),(_vm.indexMenus.length)?_c('router-view'):_vm._e(),_c('Footer'),_c('backTop')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }